import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { AssetManagerType } from '../../../../redux/userStore/reducer';
import { ORANGE } from '../../../../shared/colors';
import {
  getAssetManagers,
  updateAssetManager,
} from '../../../dashboard/network';

export const AssetUpdateForm = ({
  setShowDrawer,
  settheasset,
  getNewAsset,
}: {
  setShowDrawer: (b: boolean) => void;
  settheasset: AssetManagerType;
  getNewAsset: (part: AssetManagerType[]) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );
  form.setFieldsValue(settheasset);
  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        initialValues={settheasset}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.code = '1234';
          await updateAssetManager(connectedUser.id, settheasset.id, data).then(
            ({ statusCode, data }) => {
              if (statusCode.toString()[0] === '2') {
                notification.success({
                  message: 'Client mis à jour',
                  description: 'Votre client a été mis à jour avec succès',
                });
                getAssetManagers().then(({ data }) => {
                  getNewAsset(data);
                });
              } else {
                notification.error({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
              setShowDrawer(false);
            },
          );
        }}
      >
        <Form.Item
          label='Nom du client'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du client',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du client' />
        </Form.Item>
        <Form.Item
          label='Email du client'
          name='email'
          hasFeedback
          rules={[
            {
              required: true,
              message: "Entrez l'email du client",
            },
          ]}
        >
          <Input placeholder="Entrez l'email" />
        </Form.Item>
        <Form.Item
          label='Adresse du client'
          name='adresse'
          hasFeedback
          rules={[
            {
              required: true,
              message: "Entrez l'adresse du client",
            },
          ]}
        >
          <Input placeholder="Entrez l'adresse" />
        </Form.Item>
        <Form.Item
          label='contact du client'
          name='contact'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le numéro de téléphone du client',
            },
          ]}
        >
          <Input placeholder='Entrez le numéro de téléphone' />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
